import api from '../Auth/api'
import { AxiosError, AxiosResponse } from 'axios'
import { createEffect, createEvent, createStore } from 'effector'

export const $roles = createStore([])

export const $permissionsStatus = createStore('ok')
export const $permissionsLoading = createStore(false)

export const setPermissionsLoadingEvent = createEvent()
export const setPermissionsStatus = createEvent()

$permissionsStatus.on(setPermissionsStatus, (_, status) => status)

export const getRolesFx = createEffect(async () => {
  return await api.get('rbac/roles')
})

export const updateRoleFx = createEffect(async (data) => {
  return await api.patch('rbac/role', data)
})

export const createRoleFx = createEffect(async (data) => {
  return await api.put('rbac/role', data)
})

$roles.on(createRoleFx.finally, () => {
  getPermissionsFx()
  getRolesFx()
})

$roles.on(updateRoleFx.finally, () => {
  getPermissionsFx()
  getRolesFx()
})

$roles.on(getRolesFx, () => {
  setPermissionsLoadingEvent(true)
})

$roles.on(getRolesFx.done, (state, { result }) => {
  const roles = result.data.data
  console.log('roles - ', roles)
  return roles
})

$roles.on(getRolesFx.fail, () => {
  return []
})

$roles.on(getRolesFx.finally, () => {
  setPermissionsLoadingEvent(false)
})

export const $permissions = createStore([])

export const getPermissionsFx = createEffect(async () => {
  return await api.get('rbac/permissions')
})

$permissions.on(getPermissionsFx.done, (state, { result }) => {
  const roles = result.data.data
  return roles
})
